import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxSpinnerModule } from 'ngx-spinner';
import { SharedModule } from '../shared/shared.module';
import { OemService } from './oem.service';
import { SgzpApp6ChangePasswordSentComponent } from './sgzp-app6-change-password-sent/sgzp-app6-change-password-sent.component';
import { SgzpApp6ForgotPasswordComponent } from './sgzp-app6-forgot-password/sgzp-app6-forgot-password.component';
import { SgzpApp6InputComponent } from './sgzp-app6-input/sgzp-app6-input.component';
import { SgzpApp6LoginComponent } from './sgzp-app6-login/sgzp-app6-login.component';
import { SgzpApp6PasswordInputComponent } from './sgzp-app6-password-input/sgzp-app6-password-input.component';
import { SgzpApp6RegisterResendComponent } from './sgzp-app6-register-resend/sgzp-app6-register-resend.component';
import { SgzpApp6RegisterSendComponent } from './sgzp-app6-register-send/sgzp-app6-register-send.component';
import { SgzpApp6RegisterComponent } from './sgzp-app6-register/sgzp-app6-register.component';
import { SgzpApp6ResetPasswordComponent } from './sgzp-app6-reset-password/sgzp-app6-reset-password.component';
import { SgzpApp6UnblockComponent } from './sgzp-app6-unblock/sgzp-app6-unblock.component';
import { SgzpApp6Component } from './sgzp-app6/sgzp-app6.component';

@NgModule({
  declarations: [
    SgzpApp6Component,
    SgzpApp6LoginComponent,
    SgzpApp6RegisterComponent,
    SgzpApp6UnblockComponent,
    SgzpApp6RegisterResendComponent,
    SgzpApp6RegisterSendComponent,
    SgzpApp6ForgotPasswordComponent,
    SgzpApp6ResetPasswordComponent,
    SgzpApp6ChangePasswordSentComponent,
    SgzpApp6InputComponent,
    SgzpApp6PasswordInputComponent,
  ],
  imports: [
    CommonModule,
    NgxSpinnerModule,
    FormsModule,
    RouterModule,
    SharedModule,
  ],
  exports: [
    SgzpApp6ResetPasswordComponent,
    SgzpApp6Component,
    SgzpApp6RegisterResendComponent,
    SgzpApp6RegisterSendComponent,
    SgzpApp6UnblockComponent,
    SgzpApp6ChangePasswordSentComponent,
  ],
  providers: [OemService],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SgzpApp6Module { }
